import { createTransport, type BrowserOptions } from "@sentry/react";

// Capture before Sentry wraps console methods, so envelope logs cannot feed back
// into breadcrumbs, Replay, or the console logging integration.
// oxlint-disable-next-line no-console
const logEnvelope = console.debug.bind(console);

export const consoleEnvelopeTransport: NonNullable<BrowserOptions["transport"]> = (options) =>
  createTransport(options, async ({ body }) => {
    // Replay is uncompressed in this mode; decode serialized bytes for inspection.
    logEnvelope("[Sentry envelope: local only]", typeof body === "string" ? body : new TextDecoder().decode(body));
    return { statusCode: 200 };
  });
